module.exports = "<app-header></app-header>\n\n<div class=\"app-body\">\n  <app-sidebar></app-sidebar>\n\n  <!-- Main content -->\n  <main class=\"main\">\n    <router-outlet></router-outlet>\n  </main>\n</div>\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/app-layout/app-layout.component.html
// module id = ../../../../../src/app/layouts/app-layout/app-layout.component.html
// module chunks = 6